<template>
  <h1>Shoppin</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>